import Icx from './Icx2'
export default Icx
